import { Component, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';

import { Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { environment } from 'src/environments/environment';
import { HtmlRoutePages } from '~/app-routing.model';
import { AppState } from '~/core/store';
import { LocalesStateLang, LocalesStateLangList } from '~/core/store/locales/locales.model';
import { LocalesService } from '~/core/store/locales/locales.service';
import { RegionSettings } from '~/core/store/regionalSettings/regionalSettings.model';
import { SearchStateFilter, TruckCardTypes } from '~/core/store/search/search.model';
import { SearchService } from '~/core/store/search/search.service';
import { CurrencyCode, Truck } from '~/core/store/trucks/trucks.model';
import { GlobalUtils, MetaTagService } from '~/core/utils/global-utils/global-utils';
import { InternalMyProfileService } from '~/modules/admin-shared/services/my-profile.service';
import { UserProfile } from '~/modules/admin-shared/store/models/admin.model';
import { regionEnum } from '../../core/declaration/declaration';
import { BreadCrumbUrlService } from '../../core/services/breadcrumb/breadcrumbUrl.service';
import { RegionalSettingsService } from '../../core/store/regionalSettings/regionalSettings.service';

export enum AnimationState {
  IN = 'in',
  OUT = 'out'
}

@AutoUnsubscribe()
@Component({
  selector: 'volvo-truck',
  templateUrl: './truck.component.html',
  styleUrls: ['./truck.component.scss'],
})
export class TruckComponent implements OnInit, OnDestroy, OnChanges {
  @Input() truck: Truck;
  @Input() truckdata: Truck;
  @Input() openTruckAsPage = false;
  @Input() isSkeleton = false;
  @Input() userNavigation: string

  @Input() set cardSmall(bool: boolean) {
    this.cardSmallValue = bool;
  }

  @Input() set homePageCard(bool: boolean) {
    this.homePageCardValue = bool;
  }

  @Input() set cardType(truckCardType: TruckCardTypes) {
    this.cardTypeValue = truckCardType;
  }

  environment = environment;
  comparisonTrucks: string[] = []; // Array of truckIds

  CurrencyCode = CurrencyCode;
  HtmlRoutePages = HtmlRoutePages;
  TruckCardTypes = TruckCardTypes;
  isTrailer = true;

  truckPicture: string[] = [];
  truckId: string;
  truckUrl: string;
  curLang: LocalesStateLangList;
  truckMakeModel: string = '';
  locationImage: string = '';
  region: string;
  regionEnum = regionEnum;
  //truckMakeModel: string = '';

  private s0: Subscription;
  private s1: Subscription;
  advertisementTitle: string = '';
  @HostBinding('class.isList') cardTypeValue = TruckCardTypes.card;
  @HostBinding('class.isSmall') cardSmallValue = false;
  @HostBinding('class.isSmall') homePageCardValue = false;
  regionalSettings: RegionSettings;
  imageLoaded: boolean = true;
  site: string;
  isSelectedSite: boolean = false;
  showLocalCurrency: boolean = false;
  isOtherCategory: boolean = false;
  userProfile$: Observable<UserProfile | null>;

  constructor(
    private router: Router,
    private localesService: LocalesService,
    private globalUtils: GlobalUtils,
    private searchService: SearchService,
    private localizeRouterService: LocalizeRouterService,
    private metaTagService: MetaTagService,
    private meta: Meta,
    private translateService: TranslateService,
    private breadCrumbUrlService: BreadCrumbUrlService,
    private regionalSettingsService: RegionalSettingsService,
    private store: Store,
    private myProfileService: InternalMyProfileService
  ) {
    this.region = store.selectSnapshot<string>((state: AppState) => state.language.region.curRegion.id);
    this.regionalSettings = store.selectSnapshot<RegionSettings>((state: AppState) => state.regionalSettings.regionsSettings.filter(r => r.region === this.region)[0]);
    if (this.regionalSettings && this.regionalSettings.site === "volvoselected") this.isSelectedSite = true;
    this.initSubscriptions();
    this.userProfile$ = this.myProfileService.profile$;
  }

  ngOnInit(): void {
    // Only use sessionStorage for comparisonTrucks
    this.loadComparisonTrucks();
    // Hydrate comparisonTrucks from sessionStorage on load
    try {
      const sessionTrucks = JSON.parse(sessionStorage.getItem('comparisionTrucks') || '[]');
      this.comparisonTrucks = Array.isArray(sessionTrucks) ? sessionTrucks : [];
    } catch {
      this.comparisonTrucks = [];
    }
    if (this.truck) {
      this.initTruck();

      if (this.truck && this.truck.pictures && this.truck.pictures[1] && this.truck.pictures[1].filenameLarge) {
        this.truckPicture[1] = this.truck.pictures[1].filenameLarge;
      }
      if (this.truck && this.truck.pictures && this.truck.pictures[0] && this.truck.pictures[0].filenameLarge) {
        this.truckPicture[0] = this.truck.pictures[0].filenameLarge;
      }
      if (this.truck.specification.advertisementTitle) {
        this.advertisementTitle = this.truck.specification.advertisementTitle;
      }

      if (this.truck?.pricing?.priceExclVat?.currencyIsoCode3 !== CurrencyCode.EUR && this.truck?.pricing?.priceExclVat?.currencyIsoCode3 !== CurrencyCode.ZAR && this.truck?.ShowPrice) {
        this.showLocalCurrency = true;
      }
    }

    this.locationImage = '/assets/icons/Geopin.jpg'
  }

  ngOnChanges(changes: SimpleChanges): void {
    // No need to update isFavorite, as we now use async pipe and isTruckFavorite(profile)
  }

  ngOnDestroy(): void { }

  async openTruck(event: MouseEvent): Promise<void> {
    this.openTruckPage(event);
  }

  truncateString(string: string): string {
    let truncedString = string.substr(0, 15) + '...';

    return truncedString;
  }

  openTruckPage(event: MouseEvent): void {
    event.preventDefault();

    let navFromHome = this.router.url === '/' ? true : false;
    const make = `${this.truck.specification.make}-${this.truck.specification.model}`;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    this.breadCrumbUrlService.setPageposition(scrollTop, scrollLeft);

    let url = this.localizeRouterService.translateRoute(HtmlRoutePages.truck);
    url = (url as string).replace('//', '/en/');

    //set UserNavigation in session storage
    sessionStorage.setItem('userNavigation', this.userNavigation);

    this.router.navigate([url, this.truckId], {
      state: { fromHome: navFromHome },
    });
  }

  private initSubscriptions(): void {
    this.s0 = this.localesService.lang$.subscribe((lang: LocalesStateLang) => {
      this.curLang = lang.curLang;
    });

    this.s1 = this.searchService.filter$.subscribe((searchOptions: SearchStateFilter) => {
      const majorCategorySemiTrailer = 'semi-trailer';
      const majorCategoryTrailer = 'trailer';
      const majorCategoryOther = 'Other';
      const majorCategoryValue = searchOptions.steps.majorCategory.value;
      this.isTrailer = majorCategoryValue === majorCategorySemiTrailer || majorCategoryValue === majorCategoryTrailer;
    });
  }

  private initTruck(): void {
    if (this.isSkeleton) {
      return;
    }

    try {
      const majorCategorySemiTrailer = 'semi-trailer';
      const majorCategoryTrailer = 'trailer';
      const majorCategoryOther = 'Other';
      this.truck = new Truck(this.truck);
      const majorCategoryValue = this.truck.specification.category.toLowerCase();
      this.isTrailer = majorCategoryValue === majorCategorySemiTrailer || majorCategoryValue === majorCategoryTrailer;

      this.truckId = this.truck.stockNumber;
      this.truckMakeModel = this.truck.specification.make + ' ' + this.truck.specification.model;

      this.isOtherCategory = this.truck?.specification?.category === majorCategoryOther; //Other category

    } catch (err) {
      console.warn('Error: Truck is missing data');
      console.warn(this.truck);
    }

    if (this.globalUtils.isBrowser()) {
      try {
        const make = `${this.truck.specification.make}-${this.truck.specification.model}`;
        this.truckUrl = `${document.location.origin}${HtmlRoutePages.truck}/${this.truckId}?make=${encodeURIComponent(
          make
        )}`;
      } catch (err) {
        console.warn('Error: Truck is missing data');
      }
    }
  }

  public handleMissingImage(event: Event, type) {
    this.imageLoaded = false;
  }

  getAltText(): string {
    const make = this.truck?.specification.make || '';
    const model = this.truck?.specification.model || '';
    const horsePower = this.truck?.specification.horsePower || '';
    return `${make} ${model} ${horsePower} truck`.trim();
  }

  isUnderComparision(): boolean {
    return this.comparisonTrucks.includes(this.truck?.truckId);
  }

  toggleComparisionState() {
    if (!this.truck) return;
    this.loadComparisonTrucks();
    if (this.isUnderComparision()) {
      // Remove from sessionStorage
      this.comparisonTrucks = this.comparisonTrucks.filter(id => id !== this.truck.truckId);
    } else if (this.comparisonTrucks.length < 3) {
      // Add to sessionStorage
      this.comparisonTrucks.push(this.truck.truckId);
    }
    sessionStorage.setItem('comparisionTrucks', JSON.stringify(this.comparisonTrucks));
    // Optionally, dispatch actions if you need other side effects
    // this.store.dispatch(new AddTruckToComparison(this.truck));
    // this.store.dispatch(new RemoveTruckFromComparison(this.truck.truckId));
  }

  private loadComparisonTrucks() {
    try {
      const sessionTrucks = JSON.parse(sessionStorage.getItem('comparisionTrucks') || '[]');
      this.comparisonTrucks = Array.isArray(sessionTrucks) ? sessionTrucks : [];
    } catch {
      this.comparisonTrucks = [];
    }
  }

  isTruckFavorite(profile: UserProfile | null): boolean {
    return !!(profile && this.truck && profile.favoriteVehicles.includes(this.truck.truckId));
  }

  toggleFavorite(profile: UserProfile | null) {
    if (!this.truck || !this.truck.truckId) return;
    if (this.isTruckFavorite(profile)) {
      this.myProfileService.removeVehicleFromFavorites(this.truck.truckId);
    } else {
      this.myProfileService.addVehicleToFavorites(this.truck.truckId);
    }
  }
}
